import React, { useState, useEffect } from 'react'
import './Input.scss'

interface Props {
  id?: string
  defaultValue?: string
  className?: string
  label?: string
  variant?: string
  onChange?: (label: string, value: string) => void
  value?: string
}

const Input: React.FC<Props> = ({ id, defaultValue = '', className = '', label = '', variant = '', onChange = () => {}, value = '' }) => {
  const [currentValue, setValue] = useState(value)

  useEffect(() => {
    setValue(value)
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
    onChange(defaultValue, e.target.value)
  }

  return (
    <div className={className}>
      <input type='text' className='input-default' onChange={handleChange} aria-describedby={currentValue} required value={currentValue} />
      <span className='floating-input'>{defaultValue}</span>
    </div>
  )
}

export default Input
